module.exports = __webpack_public_path__ + "static/computer-119689d2f8ae50053501afb4190e23f6.gif";